import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import Image from '@nubank/nuds-web/components/Image/Image';
import styled from 'styled-components';
import { useParallax } from 'react-scroll-parallax';
import Grid from '@nubank/nuds-web/components/Grid/Grid';

const StyledLink = styled(Link)`
  align-items: center;
  display: flex;
  justify-content: center;
`;

const StyledImage = styled(Image)`
  min-width: 288px;
  width: 288px;

  @media (width >= 1150px) {
    min-width: 245px;
    width: 245px;
  }
`;

const StyledTitleAndImageContainer = styled(Box)`
  @media (width >= 1150px) {
    gap: 40px;
    
    picture {
      align-self: end;
    }
  }
`;

const StyledTypography = styled(Typography)`
  @media (width >= 1150px) {
    font-size: 2.2rem;
  }
`;

function MSI() {
  const { ref } = useParallax({
    opacity: [0, 1],
    easing: [0, 0.9, 1, 1.4],
  });

  return (
    <Box
      tag="section"
      height="100%"
      width="100%"
      marginBottom={{ xs: '32px', lg: '100px' }}
      paddingHorizontal={{ xs: '32px', lg: '56px' }}
    >
      <Grid
        paddingLeft={{ xs: '0', lg: '0x' }}
        paddingRight={{ xs: '0', lg: '0' }}
      >

        {/* CONTENT BOX */}

        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '2 / span 4', lg: '2 / span 10' }}
          gridRow="1"
        >

          <Box
            display="flex"
            flexDirection={{ xs: 'column' }}
            justifyContent="center"
            marginBottom={{ xs: '40px', lg: '0' }}
            paddingHorizontal={{ xs: '0', lg: '56px' }}
            maxWidth={{ xs: '100%', lg: '1215px' }}
            margin={{ xs: '0', lg: '0 auto' }}
          >

            {/* PURPLE BLOCK */}

            <StyledTitleAndImageContainer
              background={{
                xs: 'linear-gradient(137deg, #9F2DEB 42.83%, #6200A3 86.85%), #820AD1',
                lg: 'linear-gradient(97deg, #9F2DEB 36.11%, #6200A3 107.05%);',
              }}
              minHeight={{ xs: '380px', lg: '170px' }}
              display="flex"
              flexDirection={{ xs: 'column', lg: 'row' }}
              paddingTop={{ xs: '34px', lg: '0' }}
              paddingHorizontal={{ xs: '16px', lg: '0' }}
              justifyContent={{ xs: 'space-between', lg: 'center' }}
              alignItems={{ xs: 'center', lg: 'center' }}
              borderRadius="12px"
            >
              <Box
                paddingLeft={{ xs: '0', lg: '20px' }}
                position="relative"
                ref={ref}
              >
                <StyledTypography
                  variant="heading2"
                  color="white"
                  textAlign={{ xs: 'center', lg: 'left' }}
                  marginBottom="34px"
                >
                  Con MSI que
                  desafían lo establecido
                </StyledTypography>

                <StyledLink
                  href="/meses-sin-intereses-con-nu/"
                  color="white"
                  iconProps={{ name: 'arrow-up-right' }}
                  width={{ xs: '100%', lg: 'fit-content' }}
                >
                  Ver MSI con Nu
                </StyledLink>
              </Box>

              <StyledImage
                alt="Icono de un calendario"
                src="credit-card/msi/calendar3d.png"
                webp
                loading="lazy"
              />

            </StyledTitleAndImageContainer>

          </Box>
        </Grid.Child>
      </Grid>
    </Box>
  );
}

export default MSI;
